export const responsePasswordChange = 'We have just sent you an email to reset your password.';